var map = {
	"./DEFAULT.svg": "f7fd",
	"./DEFAULT_W.svg": "e2c9",
	"./R_HAZ.svg": "7e00",
	"./R_HAZ_W.svg": "c455",
	"./R_PLA.svg": "586c",
	"./R_PLA_W.svg": "e6dd",
	"./R_REF.svg": "fb78",
	"./R_REF_W.svg": "8a84",
	"./R_SEC.svg": "f853",
	"./R_SEC_W.svg": "4a63",
	"./R_TAN.svg": "dada",
	"./R_TAN_W.svg": "51e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3664";